<template>
<div>
	<!-- Barre de menu -->
	<b-navbar toggleable="lg" type="dark" style="background-color:#24AAE1 !important; display: flex; justify-content: space-between; align-items: center;" variant="dark">
		<el-button-group >
			<div id="double_button">
				<div class="button_icons">
					<el-button icon="fas fa-home" v-on:click="redirectAccueil" plain></el-button>
					<p>Accueil</p>
				</div>
				<div class="button_icons">
					<el-button icon="fas fa-archive" v-on:click="redirectDocument" plain></el-button>
					<p>Document</p>
				</div>
			</div>
		</el-button-group>
		<b-navbar-brand :to="'/indexClient'" style="padding-top: 5px;"></b-navbar-brand>
		<!-- <b-collapse is-nav id="nav_collapse"> -->
		<b-navbar-nav style="float: right;">
			<b-nav-item style="white-space:nowrap;">{{ time }}</b-nav-item>
			<b-nav-item-dropdown right>
				<template slot="button-content"><span class="fas fa-user"></span> {{ info.prenom+" "+info.nom }}</template>
				<b-dropdown-item :to="'/profilClient'"><span class="far fa-address-card"></span> Mon profil</b-dropdown-item>
				<b-dropdown-item v-on:click="disconnect()"><span class="fas fa-power-off"></span> Déconnexion</b-dropdown-item>
			</b-nav-item-dropdown>
		</b-navbar-nav>
	</b-navbar>	
</div>
</template>

<script>
import script from '../../script/script.js';

var moment = require('moment');
export default {
	
  data() {
    return {
		time: moment().format('LLLL'),
		intervalTime:null
    }
	},
	beforeCreate:function(){
		moment.locale('fr');
	},
	mounted:function(){
			this.intervalTime = setInterval(() => this.time = moment().format('LLLL'), 500)
	},
	beforeDestroy:function(){
		clearInterval(this.intervalTime);
	},
  methods: {
    	disconnect: script.disconnect,
		redirectAccueil(){
      		this.$router.push({ path: '/indexClient' })
    	},
		redirectDocument(){
      		this.$router.push({ path: '/DocumentUnique' })
    	},
	},
	created:function(){

	},
	computed:{
		info(){
			return this.$store.state.info
		}
	}
}
</script>

<style>
#double_button{
	padding-left: 1vw;
	float: left;
	display: flex;
	justify-content: space-between;
}

.button-icons{
	text-align: center;
}

#double_button button{
	background-color: transparent;
	color: white;
	border: none;
	font-size: 1.2vw;
	transition: all .5s ease;
}

#double_button p{
	font-size: 70%;
	color: white;
	margin-top: -20%;
	margin-left: 0;
	margin-bottom: 0;
	text-align: center;
	cursor: default;
}

#double_button button:hover {
	background-color: #176a8c;
}

#navbarClient{
	justify-content: unset;
}

#navbar-navClient{
	justify-content: flex-end;
}
</style>
